import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function ProjectCostsStats() {
  const statsData = [
    { name: 'Nhân công', value: 8500, color: '#3b82f6' },
    { name: 'Vật tư', value: 7200, color: '#10b981' },
    { name: 'Thuê ngoài', value: 4800, color: '#a855f7' },
    { name: 'Thiết bị', value: 3600, color: '#f59e0b' },
    { name: 'Chi phí chung', value: 2250, color: '#06b6d4' },
    { name: 'Dự phòng', value: 2000, color: '#94a3b8' },
    { name: 'Khác', value: 300, color: '#f97316' },
  ];

  return (
    <DonutLegendChart
      title="Phân bổ chi phí theo loại"
      centerValue="28.65B"
      centerLabel="Tổng ngân sách"
      data={statsData}
      total={28650}
    />
  );
}
